(() => {
  const buttonSelector = '[data-buy-now-button]';

  const setButtonAvailability = (button, variant) => {
    const available = Boolean(variant && variant.available);
    button.disabled = !available;
    button.classList.toggle('button--primary', available);
    button.classList.toggle('button--ternary', !available);
  };

  const getTransparentCheckoutUrl = () => {
    const storefrontDomain = window.location.hostname.replace(/^www\./, '');

    return `${window.location.protocol}//checkout.${storefrontDomain}/checkout`;
  };

  const submitTransparentCheckout = async () => {
    const cartResponse = await fetch(`${window.themeVariables.routes.cartUrl}.js`);
    const cart = await cartResponse.json();

    if (!cart.items || cart.items.length === 0) {
      throw new Error('Cart is empty.');
    }

    const products = cart.items.map((item) => {
      const hasVariants = !(
        item.has_only_default_variant
        || item.variant_title === 'Default Title'
        || item.variant_options?.[0] === 'Default Title'
      );

      if (hasVariants) {
        return {
          code: String(item.product_id),
          primary_variant_code: String(item.variant_id),
          quantity: item.quantity,
          amount: item.price
        };
      }

      return {
        code: `${item.product_id}/${item.variant_id}`,
        quantity: item.quantity,
        amount: item.price
      };
    });

    const checkoutForm = document.createElement('form');
    checkoutForm.action = getTransparentCheckoutUrl();
    checkoutForm.method = 'POST';
    checkoutForm.noValidate = true;

    const cartInput = document.createElement('input');
    cartInput.type = 'hidden';
    cartInput.name = 'cart';
    cartInput.value = JSON.stringify({ products });
    checkoutForm.appendChild(cartInput);

    document.body.appendChild(checkoutForm);
    checkoutForm.submit();
  };

  const addSelectedVariantAndCheckout = async (button) => {
    const form = document.getElementById(button.dataset.productFormId);

    if (!form) return;

    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');

    try {
      const formData = new FormData(form);
      formData.delete('option1');
      formData.delete('option2');
      formData.delete('option3');

      const response = await fetch(`${window.themeVariables.routes.cartAddUrl}.js`, {
        method: 'POST',
        body: formData,
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

      if (!response.ok) {
        throw new Error('Unable to add the selected variant to the cart.');
      }

      await submitTransparentCheckout();
    } catch (error) {
      console.error('Buy now failed', error);
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest(buttonSelector);

    if (!button || button.disabled) return;

    addSelectedVariantAndCheckout(button);
  });

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll(buttonSelector).forEach((button) => {
      const form = document.getElementById(button.dataset.productFormId);

      if (!form) return;

      form.addEventListener('variant:changed', (event) => {
        setButtonAvailability(button, event.detail.variant);
      });
    });
  });
})();
